<template>
<div class="user-menu">

	<b-dropdown id="user-menu"
	            :text="me.name"
	            variant="outline-info"
	            right>
		<b-dropdown-item v-on:click="handleLogout()">
			<i class="fa fa-fw fa-sign-out-alt"></i> Uitloggen
		</b-dropdown-item>
	</b-dropdown>

</div>
</template>

<script>
import router from '@/router'
import {
	mapGetters,
	mapActions
} from 'vuex'

export default {
	data() {
		return {
			User: false
		}
	},
	computed: {
		...mapGetters([
			'me'
		])
	},
	methods: {
		...mapActions([
			'logout'
		]),
		handleLogout() {
			this.logout();
			this.$router.replace('/login');
		}
	}
}
</script>



// WEBPACK FOOTER //
// UserMenu.vue?33d1d5ae